import * as React from 'react';
import { useEventCallback } from '@cian/react-utils';
import { Button, UIHeading4 } from '@cian/ui-kit';
import { useSelector } from 'react-redux';
import { pathOr } from 'ramda';
import { GalleryContainer } from '../GalleryContainer';
import { selectProjectTitle, selectProjectId } from '../../selectors';
import { GALLERY_OPTIONS } from './constants';
import { IGalleryTab } from '../../types/gallery';
import { PhoneButtonContainer } from '../PhoneButtonContainer';
import { trackPhoneOpen } from '../../utils/analytics';
import { EMediaType } from '../../types/project';
import { TourModalContainer } from '../TourModalContainer';
import { useGalleryData } from '../../hooks';

export const MainGalleryContainer = () => {
  const [activeSlide, setActiveSlide] = React.useState<number | undefined>();
  const [tourOpened, toggleTourModal] = React.useState(false);
  const { slides, tabs } = useGalleryData();
  const projectId = useSelector(selectProjectId);
  const name = useSelector(selectProjectTitle);
  const preloaderImageUrl = pathOr<string | undefined>(undefined, [0, 'img'], slides);

  const handleTabClick = React.useCallback(
    (tab: IGalleryTab) => {
      if (tab.type === EMediaType.Tour) {
        toggleTourModal(true);
      } else {
        const foundSlideIndex = slides.findIndex(slide => slide.type === tab.type);

        if (foundSlideIndex !== -1) {
          setActiveSlide(foundSlideIndex);
        }
      }
    },
    [slides],
  );

  const handleSlideChange = useEventCallback(() => {
    setActiveSlide(undefined);
  });

  const handleShowPhone = useEventCallback(() => {
    trackPhoneOpen('Open_CSP_card_projectGallery', projectId);
  });

  if (!slides.length) {
    return null;
  }

  return (
    <>
      <GalleryContainer
        slides={slides}
        name={name}
        preloaderImageUrl={preloaderImageUrl}
        galleryOptions={GALLERY_OPTIONS}
        activeSlide={activeSlide}
        phoneButton={
          <PhoneButtonContainer
            button={<Button size="XS">Показать телефон</Button>}
            contentRenderer={phone => <UIHeading4 color="text-on-bright-default">{phone}</UIHeading4>}
            onShow={handleShowPhone}
          />
        }
        tabs={tabs}
        onTabClick={handleTabClick}
        onSlideChange={handleSlideChange}
      />
      {tourOpened && <TourModalContainer onClose={() => toggleTourModal(false)} />}
    </>
  );
};
